import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { id: String, url: String }

  connect() {
    console.log("CreateClientController connected")
  }

  createNewClient(event) {
    event.preventDefault()
    
    fetch(this.urlValue, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        'Content-Type': 'application/json',
        'Accept': 'text/vnd.turbo-stream.html'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        client_id: this.idValue
      })
    })
    .then(response => {
      if (response.ok) {
        return response.text()
      } else {
        throw new Error('Failed to import client')
      }
    })
    .then(html => {
      Turbo.renderStreamMessage(html)
    })
    .catch(error => {
      console.error('Error:', error)
    })
  }

  showLinkModal(event) {
    event.preventDefault()
    const modal = document.getElementById('link_client_modal')
    const linkButton = modal.querySelector('[data-action="click->create-client#linkExistingClient"]')
    
    // Set the URL and ID values on the link button
    linkButton.dataset.createClientUrlValue = this.urlValue
    linkButton.dataset.createClientIdValue = this.idValue
    
    modal.showModal()
  }

  linkExistingClient(event) {
    event.preventDefault()
    const selectedClientId = document.getElementById('existing_client_select').value

    if (!selectedClientId) {
      alert('Please select a client')
      return
    }

    fetch(this.urlValue, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        'Content-Type': 'application/json',
        'Accept': 'text/vnd.turbo-stream.html'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        client_id: this.idValue,
        existing_client_id: selectedClientId
      })
    })
    .then(response => {
      if (response.ok) {
        return response.text()
      } else {
        throw new Error('Failed to link client')
      }
    })
    .then(html => {
      document.getElementById('link_client_modal').close()
      Turbo.renderStreamMessage(html)
    })
    .catch(error => {
      console.error('Error:', error.message)
      alert(error.message)
    })
  }
}